// GENERAL
export const OPEN_JOBS = 'openAsyncJobs';
export const CLOSE_JOBS = 'closeAsyncJobs';
export const UPDATE_JOBS = 'updateJobs';
export const START_CHECKING_JOBS = 'startCheckingJobs';
export const STOP_CHECKING_JOBS = 'stopCheckingJobs';
export const ADD_GLOBAL_HANDLER = 'addGlobalAsyncJobHandler';
export const REMOVE_GLOBAL_HANDLER = 'removeGlobalAsyncJobHandler';
export const GLOBAL_JOB_COMPLETED = 'globalJobCompleted';
